import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import PrepaidAmountInput from '@components/prepaid/PrepaidAmountInput';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import usePrepaidRechargeLimits from '../../../_shared/hooks/usePrepaidRechargeLimits';

interface Props {
    cardId: string;
    initialAmount?: number;
}

function ChargeAmount({ cardId, initialAmount }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { amount, setAmount } = useContext(PrepaidContext);
    const { data } = useQuery(userPrepaidCardQueries.detail(cardId));
    const balance = data?.balance ?? 0;
    const { textParams, getErrorText } = usePrepaidRechargeLimits();
    const errorText = getErrorText(amount, balance);

    useEffect(() => {
        if (initialAmount) {
            setAmount(Math.max(initialAmount / 10000, 0));
        }
    }, [initialAmount, setAmount]);

    return (
        <PrepaidAmountInput
            amountMan={amount}
            onChangeMan={setAmount}
            errorText={errorText}
            placeholder={t('charge.amountPlaceholder', textParams)}
            tooltipDaily={t('charge.tooltipDaily', textParams)}
            tooltipMaxBalance={t('charge.tooltipMaxBalance', textParams)}
        />
    );
}

export default ChargeAmount;
